import { ClassData } from "../../../common/dtos/classes.type";
import { DEFAULT_CATEGORY } from "../../../common/services/default-category.service";
import { submissionService } from "../../../common/services/submission.service";
import { trackingService } from "../../../common/services/tracking.service";
import {
  getDayByProperty,
  getValueByAgeCode,
} from "../../../common/utils/classes.util";
import { RYB_CLASSES_DATA } from "../../../common/utils/const.util";
import { setPendingConversion } from "../../../common/utils/conversion.util";
import { getEffectiveClassPrice } from "../../../common/utils/pricing.util";
import {
  additionalUrlParameters,
  parseRegistrationLink,
} from "../../../common/utils/url.util";
import { writeCookie } from "../utils/cookie.util";

export function openModal(cardData: ClassData) {
  const classMetadata =
    RYB_CLASSES_DATA.classes?.find(
      (category) => category.name === cardData[DEFAULT_CATEGORY]
    ) || null;
  const effectivePrice = getEffectiveClassPrice(cardData, classMetadata);
  $("#base .ryb-connect-modal .modal-title").html(cardData.category2); // do not change it is passed as category2
  $("#base .ryb-connect-modal .modal-address").html(cardData.location);
  $("#base .ryb-connect-modal .modal-price").html(
    effectivePrice.toString()
  );
  $("#base .ryb-connect-modal .modal-min-age").html(
    getValueByAgeCode(cardData.min_age)
  );
  $("#base .ryb-connect-modal .modal-max-age").html(
    getValueByAgeCode(cardData.max_age)
  );
  $("#base .ryb-connect-modal .modal-gender").html(cardData.gender);
  $("#base .ryb-connect-modal .modal-meeting-day").html(
    getDayByProperty(cardData.meeting_days)
  );
  $("#base .ryb-connect-modal .modal-start-time").html(cardData.start_time);
  $("#base .ryb-connect-modal .modal-end-time").html(cardData.end_time);
  $("#base.ryb-connect-overlay").addClass("show");
  $("#base .ryb-connect-modal .modal-description").text(
    cardData.description ||
      RYB_CLASSES_DATA.classes.find(
        (item) => cardData[DEFAULT_CATEGORY] === item.name
      )?.description ||
      ""
  );

  // Use .off() before .on() to prevent handler accumulation on repeated opens
  $("#base.ryb-connect-overlay").off("click").on("click", function () {
    closeModal();
  });

  $("#base .ryb-connect-modal .close-modal").off("click").on("click", function () {
    closeModal();
  });

  // Delegated stopPropagation instead of binding to every child element
  $("#base.ryb-connect-overlay").off("click.stopProp").on("click.stopProp", ".ryb-connect-modal", function (event) {
    event.stopPropagation();
  });

  // Scoped to #base to avoid leaking to other modals; .off() prevents accumulation
  $("#base button.register-now").off("click").on("click", function () {
    const fallbackUrl =
      classMetadata?.fallback_url || "";

    // Write classData cookie (was missing — needed for downstream tracking)
    writeCookie(
      "classData",
      btoa(unescape(encodeURIComponent(JSON.stringify({
        ...cardData,
      })))),
      365
    );

    // Track enrollment click
    trackingService.pushEvent("ryb_enroll_clicked", {
      class_name: cardData.category2 || cardData.name,
      class_id: cardData.id,
    });

    submissionService.updateSubmission({
      selected_class_name: cardData.category2 || cardData.name,
      selected_class_id: String(cardData.id),
      selection_type: "enroll",
      funnel_last_step: "enroll",
    });

    setPendingConversion({
      submissionId: submissionService.getSubmissionId(),
      className: cardData.category2 || cardData.name,
      classId: String(cardData.id),
      selectionType: "enroll",
      funnelType: "finder",
      ghlContactId: localStorage.getItem("ghlContactId"),
    });

    let url: string;
    if (cardData.online_reg_link) {
      url = parseRegistrationLink(
        cardData.online_reg_link,
        effectivePrice.toString(),
        cardData.category1,
        cardData.category2
      );
    } else {
      url = additionalUrlParameters(
        fallbackUrl,
        effectivePrice.toString(),
        cardData.category1,
        cardData.category2
      );
    }

    if (url) {
      trackingService.pushEvent("ryb_external_redirect", {
        destination_url: url,
        class_name: cardData.category2 || cardData.name,
      });
      window.open(url, "_blank");
    } else {
      console.error("No registration URL available for this class");
    }
  });
}

export function closeModal() {
  $(".ryb-connect-overlay").removeClass("show");
}
